import React from 'react';
import ReactGA from 'react-ga';
import _ from 'lodash';
import { getCurrentPage } from '../helpers';

class Feeback extends React.Component {

	trackClick = () => {

		// GA Track
		ReactGA.event({
			category: _.startCase(getCurrentPage()),
			action: 'Feedback click',
		});
	}

	render() {

		return (

			<a className="feedback large-content" href="mailto:betterbybike@bristol.gov.uk?subject=Cycle planner feedback" onClick={ this.trackClick }>
				<svg className="icon" aria-hidden="true"><use xlinkHref="#feedback" /></svg>
				<span className="text">Feedback</span>
			</a>
		)
	}
}

export default Feeback;



// WEBPACK FOOTER //
// ./src/components/Feedback.js